export type WarningMessageProps = {
  type: WarningType;
  message: string;
  typographyStyle?: string;
  textColor?: string;
};

export enum WarningType {
  WARNING = "WARNING",
}
